import React, { Component } from 'react';
import { getToken } from '../../auth/auth';
import jwt_decode from 'jwt-decode';

import './loading.css'
import { Redirect } from 'react-router-dom';
export default class Loading extends Component {

    constructor() {
        super();
        this.state = {
            user: jwt_decode(getToken()),
            redirect: false,
            rediretFor: ''
        };
      }

    // state = {
    //     user: getToken(), redirect: false, rediretFor: ''
    // }



    componentDidMount() {
        console.log("this.state.user", this.state.user)
        
        setTimeout(() => {
            // Verificar se o array acesso tem valores válidos
            const acessoValido = this.state.user.acesso && 
                                 Array.isArray(this.state.user.acesso) && 
                                 this.state.user.acesso[0] !== null;
            
            if (acessoValido) {
                // Lógica original baseada no array acesso
                if(this.state.user.acesso.indexOf(1) !== -1)
                    this.setState({ rediretFor: '/home', redirect: true })
                else if(this.state.user.acesso.indexOf(2) !== -1)
                    this.setState({ rediretFor: '/aprovacao', redirect: true })
                else if(this.state.user.acesso.indexOf(5) !== -1 || this.state.user.acesso.indexOf(8) !== -1)
                    this.setState({ rediretFor: '/cadastro', redirect: true })
                else if(this.state.user.acesso.indexOf(3) !== -1 || this.state.user.acesso.indexOf(4) !== -1)
                    this.setState({ rediretFor: '/relatorios-protheus', redirect: true })
                else if(this.state.user.acesso.indexOf(6) !== -1 || this.state.user.acesso.indexOf(7) !== -1)
                    this.setState({ rediretFor: '/relatorios', redirect: true })
                else
                    this.setState({ rediretFor: '/home', redirect: true }) // Default para home
            } else {
                // Fallback baseado no id_perfil quando acesso é [null]
                console.log("Array acesso inválido, usando id_perfil como fallback:", this.state.user.id_perfil);
                
                switch(this.state.user.id_perfil) {
                    case 1: // Admin
                    case 6: // Super Admin  
                        this.setState({ rediretFor: '/home', redirect: true });
                        break;
                    case 2: // Aprovador
                        this.setState({ rediretFor: '/aprovacao', redirect: true });
                        break;
                    case 3: // Relatórios Protheus
                    case 4: // Usuário comum (você)
                        this.setState({ rediretFor: '/home', redirect: true });
                        break;
                    case 5: 
                        this.setState({ rediretFor: '/cadastro', redirect: true });
                        break;
                    default:
                        this.setState({ rediretFor: '/home', redirect: true });
                }
            }
        }, 1200)
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.rediretFor} />
        }
        else {
            return (
                <div >
                    <div className="cssload-loader" style={{ zoom: '3', marginTop: 22 }}>
                        <div className="cssload-inner cssload-one"></div>
                        <div className="cssload-inner cssload-two"></div>
                        <div className="cssload-inner cssload-three"></div>
                    </div>
                    <div className="row col-md-12" style={{ marginTop: 10, textAlign: 'center' }}>
                        <h2 style={{ fontWeight: 'bold' }}>Seja bem vindo, estamos construindo seu ambiente !</h2>
                    </div>
                </div>
            )
        }
    }
}
